import { useQueryClient } from '@tanstack/react-query'
import TransitApiConfig from '../../../TransitOperationEditor/hooks/apiConfig'
import reassignTransitOperation from './api'

const { queryKeys: { rootPath } } = TransitApiConfig.paths.transitOperation

export default function useReassignTransitOperation() {
  const queryClient = useQueryClient()

  const reassignTransitOperationToNewOwner = async (id: number, newCustomerId: number) => {
    if (id === null || id === undefined) throw new Error('Transit Operation ID cannot be null or undefined!')

    if (newCustomerId === null || newCustomerId === undefined) throw new Error('Customer ID cannot be null or undefined!')

    await reassignTransitOperation({
      newCustomerId,
      transitOperationId: id,
    })
    await queryClient.invalidateQueries({ queryKey: [rootPath] })
  }

  return {
    reassignTransitOperationToNewOwner,
  }
}
